import Config from "../config/Config";

export default {
  statusHelpLink: `${Config.marathonDocsURI}marathon-ui` +
    ".html#application-status-reference"
};



// WEBPACK FOOTER //
// ./src/js/constants/Links.js